import { ModulesConfiguration, Pagination, PromotionalBanner, SystemSettings, User } from '@interfaces';
import { Product, ProductHistory } from 'src/app/_interfaces/product';

export const defaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'surname',
  orderDir: 'desc',
  count: 0,
};

export type SystemSettingsState = Readonly<{
  loading: boolean;
  errorMessage: string | null;
  systemSettings: SystemSettings;
  loadingAdmins: boolean;
  loadedAdmins: Partial<User>[];
  loadedAdminsPagination: Pagination;
  loadedAdminData: Partial<User> | null;
  selfRegisterActive: boolean;
  modulesConfiguration: ModulesConfiguration;

  products: Product[];
  productHistory: ProductHistory[];
  loadingOnlineUsers: boolean;
  loadedOnlineUsers: Partial<User>[];
  loadedOnlineUsersPagination: Pagination;
  loadedOnlineUserData: Partial<User> | null;

  promotionalBanner: PromotionalBanner;
  loadingPromotionalBanner: boolean;
}>;

export const initialState: SystemSettingsState = {
  loading: false,
  errorMessage: null,
  systemSettings: null,
  loadingAdmins: false,
  loadedAdmins: [],
  loadedAdminsPagination: { ...(defaultPagination as Pagination) },
  loadedAdminData: null,
  selfRegisterActive: false,
  modulesConfiguration: null,

  products: [],
  productHistory: [],
  loadingOnlineUsers: false,
  loadedOnlineUsers: [],
  loadedOnlineUsersPagination: { ...(defaultPagination as Pagination) },
  loadedOnlineUserData: null,

  promotionalBanner: {
    promotionalBannerMessage: null,
    promotionalBannerIsActive: false,
  },
  loadingPromotionalBanner: false,
};
